import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    delay: Number,
    duration: Number,
  };

  static classes = ["fade"];

  connect() {
    setTimeout(() => {
      this.element.classList.add(...this.fadeClasses);

      setTimeout(() => {
        this.element.remove();
      }, this.durationValue);
    }, this.delayValue);
  }
}
